import BForm from "./BForm";

export default class BRecaptchaForm extends BForm
{
	static selector = () => `.b-recaptcha-form`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("submit", function (event) {
			if (event.target.matches(BRecaptchaForm.selector())) {
				const form = new BRecaptchaForm(event.target);
				form.disable();

				try {
					if (!form.el.querySelector(`[name="captchaToken"]`)) {
						let input = document.createElement("input");
						input.type = "hidden";
						input.name = "captchaToken";

						form.el.append(input);
					}

					let tokenInput = form.el.querySelector(`[name="captchaToken"]`);
					if (!tokenInput?.value) {
						event.preventDefault();
						event.stopPropagation();

						grecaptcha.enterprise.ready(function () {
							grecaptcha.enterprise.execute(_config.recaptcha.key, {
								action: "SUBMIT_FORM",
							}).then(function (token) {
								tokenInput.value = token;
								form.enable();
								form.el.submit();
							});
						});
					}
				} catch (error) {
					form.enable();
					form.el.submit();
				}
			}
		}, {
			capture: true,
		});
	}
}
